import React, { useEffect } from 'react';
import { defineNextPage } from '@/common/next';
import Head from 'next/head';
import IPadTips from '@/components/IPadTips';
import { useLanguageStore } from '$/store/languageStore';
import { setHomeVersionCookie } from '@/common/homeVersionCookie';
import { useCommonStore } from '@/store/useCommonStore';
import HomeSubscribeActivityBanner from './components/HomeSubscribeActivityBanner';
import styles from './index.module.scss';
import HomePopups from './components/HomePopups';
import HomeMain from './components/HomeMain';
import HomeInput from './components/HomeInput';

export default defineNextPage<{
  title: string;
}>({
  pageConfig: {
    projectId: '/--roboneo',
    layoutId: 'RoboneoLayout',
    renderHead({ pageProps }) {
      return (
        <Head>
          <title>RoboNeo</title>
          <link key="canonical" rel="canonical" href="https://www.roboneo.com/home" />
          {/* 首页仅声明已确认的英文及默认搜索入口。 */}
          <link key="alternate-en" rel="alternate" hrefLang="en" href="https://www.roboneo.com/home" />
          <link key="alternate-default" rel="alternate" hrefLang="x-default" href="https://www.roboneo.com/home" />
        </Head>
      );
    },
  },
  /** 首页内容区承载 IP 入口，角色选择弹窗由共享布局统一挂载。 */
  component: function HomePage() {
    const translate = useLanguageStore((state) => state.languageStore.smartcatTranslationText);
    const navbarExpand = useCommonStore((state) => state.navbarExpand);

    useEffect(() => {
      setHomeVersionCookie('new');
    }, []);

    return (
      <>
        <HomeSubscribeActivityBanner />
        <div className={styles.mainBox}>
          {/* 顶部banner背景图 */}
          <div
            className={`${styles.top_banner_bg_img} ${!navbarExpand ? styles.sidebar_expanded : ''}`}
          >
            <div className={styles.top_area}>
              <h1>
                {translate((value) => value.what_would_you_like_to_create)}
              </h1>
              <div className={styles.input_box}>
                <HomeInput />
              </div>
            </div>
          </div>

          {/* 内容区域 */}
          <HomeMain />
        </div>
        {/* ipad 提示 */}
        <IPadTips />

        {/* 统一处理首页弹窗 */}
        <HomePopups />
      </>
    );
  },
});
